import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";

export class NativePlatformService {
  async initialize(): Promise<void> {
    if (!Capacitor.isNativePlatform()) return;

    await StatusBar.setBackgroundColor({ color: "#030812" });
    await StatusBar.setStyle({ style: Style.Light });

    await App.addListener("backButton", ({ canGoBack }) => {
      if (canGoBack) {
        window.history.back();
      } else {
        void App.minimizeApp();
      }
    });
  }
}
